import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  useMediaQuery,
  TableContainer,
  Paper,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import api from "../../../services/api";

const ViewCreditsActivityModal = ({ member, open, onClose }) => {
  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (open && member) {
      setLoading(true);
      api
        .get(`/admin/digitalLoyalty/${member._id}/creditActivity`)
        .then((response) => setActivity(response.data.creditActivity))
        .catch((err) => {
          console.error("Error fetching credit activity:", err);
          setError("Failed to load credit activity.");
        })
        .finally(() => setLoading(false));
    }
  }, [member, open]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: isMobile ? "90vw" : 600,
          maxHeight: "90vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}>
        <Typography
          variant="h6"
          align="center"
          sx={{ fontWeight: "bold", mb: 2 }}>
          Credit Activity
        </Typography>

        <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress />
            </Box>
          ) : error ? (
            <Typography color="error">{error}</Typography>
          ) : activity.length > 0 ? (
            <Box sx={{ flex: 1, overflow: "hidden" }}>
              <TableContainer
                component={Paper}
                sx={{
                  maxHeight: "55vh",
                  overflow: "auto",
                  boxShadow: "none",
                }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      {["Date", "Type", "Amount", "Reason"].map((label) => (
                        <TableCell
                          key={label}
                          sx={{
                            fontWeight: "bold",
                            backgroundColor: "background.paper",
                          }}>
                          {label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {activity.map((entry, index) => (
                      <TableRow key={index} sx={{ "& td": { py: 1.5 } }}>
                        <TableCell>
                          {new Date(entry.timestamp).toLocaleString()}
                        </TableCell>
                        <TableCell>{entry.type}</TableCell>
                        <TableCell>{entry.amount}</TableCell>
                        <TableCell>{entry.reason}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          ) : (
            <Typography>No credit activity available.</Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ViewCreditsActivityModal;
